import type { ReactNode } from 'react';
import { StatePanel, V2Button } from '@sakhtar/design-system/react';
import { isStatutoryBook, useFinanceBook } from './useFinanceBook.js';

/**
 * Taxpayer-system (Moadian) and VAT filing work on the statutory book only
 * (D-022 DEC-4). While the management book is the chosen one, its tabs are
 * hidden; this covers someone opening such a page's URL directly, and renders
 * nothing of the page (so none of its requests are made) until the statutory
 * book is chosen.
 */
export function StatutoryOnly({ feature, children }: { feature: string; children: ReactNode }) {
  const { ready, statutoryFeaturesAvailable, books, select } = useFinanceBook();
  if (!ready || statutoryFeaturesAvailable) return <>{children}</>;
  const statutory = books.find(isStatutoryBook);
  return (
    <StatePanel
      variant="permission_denied"
      title={`${feature} فقط برای دفتر قانونی است`}
      description="دفتر مدیریتی انتخاب شده است. برای استفاده از این بخش، دفتر قانونی را انتخاب کنید."
      action={
        statutory ? (
          <V2Button type="button" variant="primary" onClick={() => select(statutory.bookId)}>
            رفتن به دفتر قانونی
          </V2Button>
        ) : undefined
      }
    />
  );
}
